var GridPreferencePanelsValue;

(function (GridPreferencePanelsValue) {
  GridPreferencePanelsValue["filters"] = "filters";
  GridPreferencePanelsValue["columns"] = "columns";
})(GridPreferencePanelsValue || (GridPreferencePanelsValue = {}));

export { GridPreferencePanelsValue };


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/preferencesPanel/gridPreferencePanelsValue.js
// module id = 180
// module chunks = 25